import { render, staticRenderFns } from "./CustomSortControl.vue?vue&type=template&id=424f4f87"
import script from "./CustomSortControl.vue?vue&type=script&lang=js"
export * from "./CustomSortControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports